import i18n from 'i18next'
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { render } from "react-dom"
import ReactMarkdown from "react-markdown";

i18n
  .use(Backend)
  // Автоматическое определение языка 
  .use(LanguageDetector)
  // модуль инициализации
  .use (initReactI18next)
  .init({
    // Стандартный язык
    fallbackLng: 'ru',
    debug: false,
    // Распознавание и кэширование языковых кук
    detection: {
      order: ['queryString', 'cookie'],
      cache: ['cookie']
    },
    ns: ['author', 'consultation', 'course', 'footer', 'interview', 'main', 'mentoring', 'menu', 'organization_info', 'report', 'reviewList', 'reviews', 'services', 'tariff'],
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Путь с поддержкой namespaces
    },
  })

export default i18n;